<template>
  <div>
    <label class="form-control-label">
      <h5>Campaign Name</h5>
    </label>
    <input
      ref="name"
      type="text"
      v-model="name"
      maxlength="255"
      @change="update"
      :disabled="!canEdit"
      class="form-control"
    />
    <nameValidation :$v="$v" />
  </div>
</template>

<script>
import { weeklyLoginService } from "@/api/client";
import nameValidation from "../validation/name.vue";
import { FormEditValidateRule as validateRules } from "../validation";

export default {
  props: ["campaign"],

  components: {
    nameValidation,
  },

  data() {
    return { name: "" };
  },

  validations: { name: validateRules.name },

  computed: {
    canEdit() {
      return ["draft"].includes(this.campaign.status);
    },
  },

  methods: {
    async isFormValid() {
      if (this.$v.name.$invalid) {
        await this.$dialogs.alert("กรุณากรอก Campaign Name ให้ถูกต้อง");
        this.name = this.campaign.name;
        this.$refs.name.focus();
        return false;
      }
      return true;
    },

    async update() {
      try {
        const formValid = await this.isFormValid();
        if (!formValid) return;

        const { id } = this.campaign;

        await weeklyLoginService.updateCampaignInfo(id, {
          name: this.name,
        });

        this.$notify(`Campaign name updated.`);
        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Update Campaign name error.`);
      }
    },
  },

  mounted() {
    this.name = this.campaign.name;
  },
};
</script>

<style lang="scss" scoped>
.form-control-label {
  padding-left: 0px;
  h4 {
    margin-bottom: 0.5em;
  }
}
</style>
